<template>
    <div class="flex flex-wrap justify-center align-middle">
        <template v-if="row.serial_number">
            <div class="w-full text-gray-500 text-sm text-left">
                {{ $t('common.sn_colon') }} {{ row.serial_number }}
            </div>

            <div class="w-full text-gray-400 text-xs text-left">
                {{ row.reference }}
            </div>
        </template>

        <div v-else class="w-full text-gray-500 text-sm text-left">
            {{ row.reference }}
        </div>
    </div>
</template>

<script setup>
defineProps({
    row:
    {
        type:     Object,
        required: true,
    },

    rows:
    {
        type:     Array,
        required: true,
    },

    column:
    {
        type:     Object,
        required: true,
    },

    updating:
    {
        type:    Boolean,
        default: false,
    },
});
</script>
